import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import styles from '@jobcase/react_pattern_library/styles/rebrand';

import { routeToEmployerCenter } from '../../redux/nodes/router/actions';

const LogoButton = styled.button`
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  height: 76px;
  justify-content: center;
  padding: ${styles.spacing.extraTiny}px;
  width: 100%;

  ${({ isLabelHidden }) => (isLabelHidden && css`
    transition: 0.1s ease-in-out 0.3s;
  `)}

  @media (min-width: ${styles.breakpoint.md}) {
    img {
      max-width: ${({ isLabelHidden }) => (isLabelHidden ? '40px' : '210px')};
    }
  }
`;

const Logo = ({ isLabelHidden }) => (
  <LogoButton className="logo" onClick={routeToEmployerCenter} isLabelHidden={isLabelHidden}>
    <img
      alt="Jobcase employer center"
      className="logo-image"
      isLabelHidden={isLabelHidden}
      src={isLabelHidden ? '/static-ec/rounded-logo.svg' : '/static-ec/jobcase-for-employers-indigo.svg'}
    />
  </LogoButton>
);

Logo.propTypes = {
  isLabelHidden: PropTypes.bool,
};

Logo.defaultProps = {
  isLabelHidden: false,
};

export default Logo;
